import React, { useState, useEffect, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate,updatedata, sendwhatsappmessage, WAITINGGIF} from "../../util/global";


const AmazonConfigForm = ({ showmodal, setshowmodal, amazonconfig, updateamazonconfig, setamazonconfig}) => {
    
  useEffect(() => { 

  }, [showmodal]);


  if (showmodal != "showamazonconfigform" ) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
          

           <div className="form-group">
            <label>Amazon Config</label>
            <textarea 
              type="text" 
              className="form-input" 
              id="amazonconig"
              value={amazonconfig ? amazonconfig.config : ""} 
              onChange={(e) => {  setamazonconfig({...amazonconfig, config:e.target.value}) }}
            />              
          </div>
        
          <button className="btn-blue full-width " onClick={() => {updateamazonconfig();}}>
            Save <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AmazonConfigForm;
